module.exports = __webpack_public_path__ + "static/media/DSCN0677.08619fee.jpg";